import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { InsightsSection } from '../components/InsightsSection';
import { HardHatIcon } from 'lucide-react';
export function ConstructionInvestigations() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-354">
      <Header data-id="element-355" />

      {/* Banner Section */}
      <section className="relative w-full h-[400px] bg-gradient-to-br from-kgi-blue-900 to-kgi-blue-800 overflow-hidden mt-20" data-id="element-356">
        <div className="absolute inset-0 bg-black opacity-20" data-id="element-357"></div>
        <div className="relative container mx-auto px-4 h-full flex items-center justify-center" data-id="element-358">
          <div className="text-center" data-id="element-359">
            <HardHatIcon className="h-20 w-20 text-white mx-auto mb-6 drop-shadow-lg" data-id="element-360" />
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-lg" data-id="element-361">
              Construction Investigations
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto drop-shadow" data-id="element-362">
              Specialized investigation services for construction site injuries
              and fraud
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-363">
        <div className="container mx-auto px-4" data-id="element-364">
          <div className="max-w-4xl mx-auto" data-id="element-365">
            <div className="prose prose-lg max-w-none mb-12" data-id="element-366">
              <p className="text-xl text-gray-700 leading-relaxed mb-6" data-id="element-367">
                Koda Group Inc. employs Certified Construction Investigators who
                specialize in job site injury cases, workers' compensation
                fraud, and construction-related disputes. Our investigators
                understand the unique challenges of construction site
                investigations, including OSHA regulations, safety protocols,
                and the complex relationships between contractors,
                subcontractors, and workers. We provide the specialized
                expertise needed to investigate construction accidents, verify
                injury claims, and uncover fraud.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-368">
                Construction site investigations require technical knowledge and
                industry experience. Our certified investigators have worked
                extensively in construction environments and understand how to
                document site conditions, interview workers, and analyze
                accident scenes. We work with insurance companies, attorneys,
                and contractors to investigate workers' compensation claims,
                verify the legitimacy of injuries, and document fraudulent
                activity. Our detailed reports and expert testimony can make the
                difference in construction litigation cases.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-369">
                Our construction investigation services include job site injury
                investigations, workers' compensation fraud detection, accident
                scene reconstruction, OSHA compliance verification, contractor
                and subcontractor background checks, equipment failure analysis,
                surveillance of injured workers, witness interviews and
                statements, and expert testimony in construction litigation. We
                help insurance companies and legal professionals make informed
                decisions about construction-related claims.
              </p>
            </div>

            <div className="text-center bg-gray-50 rounded-lg p-8" data-id="element-370">
              <h3 className="font-serif text-2xl font-bold text-kgi-blue-900 mb-4" data-id="element-371">
                Need Construction Investigation Expertise?
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-372">
                Contact our certified construction investigators for a
                consultation about your case.
              </p>
              <a href="/contact-koda-private-investigators.html" className="inline-flex items-center bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-xl text-lg" data-id="element-373">
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      </section>

      <InsightsSection data-id="element-374" />
      <Footer data-id="element-375" />
    </div>;
}